import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography
} from "@mui/material";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import ImageUploading from "react-images-uploading";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import RichTextEditor from "react-rte";
import * as yup from "yup";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { categoryApi } from "../../store/categoryDetails/categoryList";
import { classGlobalApi } from "../../store/class/classListGlobal";
import { addpblApi } from "../../store/pbl/addpbl";
import { EditpblApi } from "../../store/pbl/editpbl";
import { getParticularpblAPI, resetgetparticularpbl } from "../../store/pbl/getparticularpbl";
import { subjectGlobalApi } from "../../store/subject/subjectListGlobal";
import { topicsGlobalApi } from "../../store/topics/topicsListGlobal";
import {
  uploadHandoutsApi
} from "../../store/upload/uploadHandouts";
import { uploadImageApi } from "../../store/upload/uploadImage";
import BackdropUI from "../../ui/Backdrop";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const schema = yup
  .object({
    title: yup.string().required("Please Provide Content Name").trim(),
    points: yup
      .number()
      .required("Please Provide Number Of Stars ")
      .min(1, "Minimum stars should be 1")
      .max(1000, "Max Stars Can Be 1000")
      .typeError("Please provide a number"),
    topics: yup.array()
      .of(yup.string())
      .min(1, 'At least one topics is required')
      .required(),
    is_approved: yup.string().required("Please Select Option "),
    language: yup.string().required("Please Select Language "),
  })
  .required();

export default function EditPbl() {
  const theme = useTheme();
  const [fileUploadLoader, setFileUploadLoader] = useState(false);

  const { result: classList, loading: classLoading } = useSelector((state) => state?.classGlobal);
  const { result: subjectList, loading: subjectLoading } = useSelector((state) => state?.subjectGlobal);
  const { result: topicsList, loading: topicsLoading } = useSelector((state) => state?.topicsGlobal);
  const shortVideoEdit = useSelector((state) => state?.editPbl);
  const shortVideoAdd = useSelector((state) => state?.addPbl);
  const shortVideoDetail = useSelector((state) => state?.getparticularDetailspbl);
  const uploadImage = useSelector((state) => state?.uploadImage);
  const { result, loiding } = shortVideoDetail;
  const {
    result: {
      title,
      // video_url,
      mobile_number,
      duration: timeDuration,
      points,
      meta_tags,
      topics,
    },
  } = shortVideoDetail;

  const dispatch = useDispatch();
  const refInput = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
    setValue
  } = useForm({ resolver: yupResolver(schema), defaultValues: {} });
  const uploadHandouts = useSelector((state) => state?.uploadHandouts);
  const [cat, setCat] = useState();
  const [meta, setMeta] = useState("");
  const [metaTag, setMetaTag] = useState([]);
  const [images, setImages] = React.useState([]);
  const [duration, setDuration] = useState('0:00');
  const [imageLink, setImageLink] = useState();
  const ref = useRef(null);
  const params = useParams();
  const navigate = useNavigate();
  const [is_approved, setisApproved] = useState();
  const [classValue, setClassValue] = useState();
  const [language, setLanguage] = useState();
  const [chooseSubjects, setChooseSubjects] = useState();
  const categories = useSelector((state) => state?.categories);
  const [valueDescription, setValueDescription] = useState("");
  const [handOuts, setHandouts] = React.useState([]);
  const [editorValue, setEditorValue] = React.useState(
    RichTextEditor.createValueFromString('', "markdown")
  );
  useEffect(() => {

    return () => {
      dispatch(resetgetparticularpbl());

    }
  }, [])
  useEffect(() => {
    dispatch(categoryApi());
    dispatch(classGlobalApi());
    dispatch(topicsGlobalApi());
    dispatch(subjectGlobalApi());
    if (params.id) {
      dispatch(getParticularpblAPI(params.id));
    }
  }, []);
  useEffect(() => {
    setDuration(timeDuration);
    setCat(shortVideoDetail.result?.topics);
    setClassValue(shortVideoDetail.result?.classes)
    setChooseSubjects(shortVideoDetail.result?.subjects)
    setLanguage(shortVideoDetail.result?.language)
    setisApproved(shortVideoDetail.result?.is_approved)
    setImageLink(
      shortVideoDetail.result?.thumbnail
    );
    if (meta_tags) {
      setMetaTag(meta_tags.split(","));
    }
    //console.log(duration);
  }, [shortVideoDetail]);

  const onUploadHandout = async (file) => {
    setFileUploadLoader(true)
    let formData = new FormData();
    formData.append("file", file);
    dispatch(uploadHandoutsApi(formData)).then((res) => {
      if (res.payload.result.length > 0 && !res.payload.result.error) {
        let obj = {
          fileName: file.name,
          fileUrl: res.payload.result,
        };
        setHandouts([...handOuts, obj]);
        refInput.current.value = null;
        setFileUploadLoader(false)
      }
    })
  };
  const onUploadImage = async (imageList, addUpdateIndex) => {
    setFileUploadLoader(true)
    if (imageList.length > 0) {
      let formData = new FormData();

      formData.append("file", imageList[0]?.file);
      // await dispatch(uploadImageApi(formData));
      const res = await dispatch(uploadImageApi(formData));
      try {
        if (res?.payload?.status === 400) {
          setImages([]);
          return
        }
      } finally {
        setFileUploadLoader(false)
      }
    }
    setImages(imageList);
    setFileUploadLoader(false)
  };

  const handleUpdateForm = async (data) => {

    var newObj;

    if (imageLink) {
      newObj = { ...data, thumbnail: imageLink };
    } else if (images.length > 0 && !uploadImage?.loading && uploadImage.result) {
      newObj = { ...data, thumbnail: uploadImage.result };
    } else {
      toast.error("Please Upload An Image", {
        id: "toast",
        duration: 1000,
        position: "top-center",
      });
      return;
    }
    if (handOuts.length === 0) {

      toast.error("Please Upload An File", {
        id: "toast",
        duration: 1000,
        position: "top-center",
      });
      return;
    }
    if (metaTag.length < 5) {
      toast.error("Please provide 5 meta tags", {
        id: "toast",
        duration: 4000,
        position: "top-center",
      });
      return
    }
    newObj = {
      ...newObj, meta_tags: metaTag.join(","),
      file: handOuts[0].fileUrl,
      file_name: handOuts[0].fileName,
    };
    // const { classes, video_url, ...rest } = newObj
    // console.log("asdaskjdhsadj", newObj)
    // return false;
    if (params.id) {
      newObj = { ...newObj, id: params.id };
      await dispatch(EditpblApi(newObj));
      if (!shortVideoEdit?.loading) {
        navigate("/pbl-management");

      }
    } else {
      await dispatch(addpblApi(newObj));
      if (!shortVideoAdd?.loading) {
        navigate("/pbl-management");
      }
    }
  };
  const handleHandoutDelete = (element) => {
    var local = handOuts;
    setHandouts(local.filter((item) => item !== element));
  };
  const handleChipDelete = (element) => {

    var local = metaTag;
    setMetaTag(local.filter((item) => item !== element));
  };
  const handleChipAdd = (value) => {
    if (!metaTag.includes(ref?.current?.value.trim())) {
      setMetaTag([...metaTag, meta]);
      setMeta(null);
      ref.current.value = null;
    } else {
      toast.error("This Meta Tag Already Exists", {
        id: "toast",
        duration: 4000,
        position: "top-center",
      });
    }
    //console.log(ref);
  };

  useEffect(() => {
    let defalutValues = {};
    defalutValues["title"] = result?.title;
    // defalutValues["video_url"] = result?.video_url;
    defalutValues["thumbnail"] = result?.thumbnail;
    defalutValues["points"] = result?.points;
    defalutValues["topics"] = result?.topics?.map(o => o?.id);
    defalutValues["language"] = result?.language;
    defalutValues["is_approved"] = result?.is_approved;
    defalutValues["subjects"] = result?.subjects?.map(o => o?.id);
    defalutValues["pbl_class"] = result?.pbl_class?.map(o => o?.id);

    defalutValues["total_time"] = result?.total_time;
    defalutValues["description"] = result?.description;
    defalutValues["learning_outcome"] = result?.learning_outcome;
    defalutValues["day_wise"] = result?.day_wise;
    defalutValues["reference"] = result?.reference;
    defalutValues["previous_learning"] = result?.previous_learning;
    defalutValues["supplies"] = result?.supplies;





    if (result?.description) {
      setEditorValue(
        RichTextEditor.createValueFromString(
          result?.description,
          "html"
        )
      );
    }
    if (result?.file && result?.file_name) {
      let document = { file: result?.file, fileName: result?.file_name }
      setHandouts([document]);
    }
    reset(defalutValues);
  }, [result]);
  const getSecondsFromHHMMSS = (value) => {
    const [str1, str2, str3] = value.split(":");

    const val1 = Number(str1);
    const val2 = Number(str2);
    const val3 = Number(str3);

    if (!isNaN(val1) && isNaN(val2) && isNaN(val3)) {
      return val1;
    }

    if (!isNaN(val1) && !isNaN(val2) && isNaN(val3)) {
      return val1 * 60 + val2;
    }

    if (!isNaN(val1) && !isNaN(val2) && !isNaN(val3)) {
      return val1 * 60 * 60 + val2 * 60 + val3;
    }

    return 0;
  };
  const toHHMMSS = (secs) => {
    const secNum = parseInt(secs.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const seconds = secNum % 60;

    return [hours, minutes, seconds]
      .map((val) => (val < 10 ? `0${val}` : val))
      .filter((val, index) => val !== "00" || index > 0)
      .join(":")
      .replace(/^0/, "");
  };
  const handleDurtion = (e) => {
    //console.log(e.target.value)
    const value1 = e.target.value;
    const seconds = Math.max(0, getSecondsFromHHMMSS(value1));

    const time = toHHMMSS(seconds);

    setDuration(time);
  }
  const handleChange = (value) => {
    setEditorValue(value);
    setValueDescription(value.toString("html"));
  };
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>

                <Typography>Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />


                  <>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Project Title/ Name</InputLabel>
                        <OutlinedInput
                          {...register("title")}
                          label="Project Title/ Name"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.title?.message}
                          defaultValue={result.title}
                        />
                        <FormHelperText error>
                          {errors?.title?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Topics
                        </InputLabel>
                        <Controller
                          name="topics"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <Select
                              {...field}
                              multiple
                              value={watch('topics', [])}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                setValue('topics', typeof value === 'string' ? value.split(',') : value);
                                field.onChange(e);
                              }}
                              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                              renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((value) => (
                                    <Chip key={value} label={topicsList.find(obj => obj.id === value)?.title || ""} />
                                  ))}
                                </Box>
                              )}
                              MenuProps={MenuProps}
                            >
                              {topicsList.map((obj) => (
                                <MenuItem
                                  key={obj.title}
                                  value={obj.id}
                                  style={getStyles(obj.title, watch('topics', []), theme)}
                                >
                                  {obj.title}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        <FormHelperText error>
                          {errors?.topics?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Description</InputLabel>
                        <OutlinedInput
                          {...register("description")}
                          label="Description"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.description?.message}
                          defaultValue={result.description}
                          multiline={true}
                        />
                        <FormHelperText error>
                          {errors?.description?.message}
                        </FormHelperText>
                      </FormControl>

                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Total Time Required
                        </InputLabel>
                        <OutlinedInput
                          {...register("total_time")}
                          label="Total Time Required"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.total_time?.message}
                          defaultValue={result.total_time}
                        />
                        <FormHelperText error>
                          {errors?.total_time?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Supplies Required
                        </InputLabel>
                        <OutlinedInput
                          {...register("supplies")}
                          label="Supplies Required"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.supplies?.message}
                          defaultValue={result.supplies}
                          multiline={true}
                        />
                        <FormHelperText error>
                          {errors?.supplies?.message}
                        </FormHelperText>
                      </FormControl>

                    </Stack>

                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Learning Outcome</InputLabel>
                        <OutlinedInput
                          {...register("learning_outcome")}
                          label="Learning Outcome"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.learning_outcome?.message}
                          defaultValue={result.learning_outcome}
                          multiline={true}
                        />
                        <FormHelperText error>
                          {errors?.learning_outcome?.message}
                        </FormHelperText>
                      </FormControl>

                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Day Wise Activity Detals of the Project</InputLabel>
                        <OutlinedInput
                          {...register("day_wise")}
                          label="Day Wise Activity Detals of the Project"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.day_wise?.message}
                          defaultValue={result.day_wise}
                          multiline={true}
                        />
                        <FormHelperText error>
                          {errors?.day_wise?.message}
                        </FormHelperText>
                      </FormControl>

                    </Stack>

                    <Stack direction="row" spacing={2}>

                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Refrence</InputLabel>
                        <OutlinedInput
                          {...register("reference")}
                          label="Refrence"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.reference?.message}
                          defaultValue={result.reference}
                          multiline={true}
                        />
                        <FormHelperText error>
                          {errors?.reference?.message}
                        </FormHelperText>
                      </FormControl>

                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Previous Learning Required</InputLabel>
                        <OutlinedInput
                          {...register("previous_learning")}
                          label="Previous Learning Required"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.previous_learning?.message}
                          defaultValue={result.previous_learning}
                          multiline={true}
                        />
                        <FormHelperText error>
                          {errors?.previous_learning?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>

                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Allocated Stars</InputLabel>
                        <OutlinedInput
                          {...register("points")}
                          label="Allocated Stars"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.points?.message}
                          defaultValue={result.points}
                        />
                        <FormHelperText error>
                          {errors?.points?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel>Meta Tag</InputLabel>
                        <OutlinedInput
                          label="meta_tag"
                          id="outlined-adornment-email"
                          onChange={(e) => {
                            if (e.target.value.trim().length > 0) {
                              setMeta(e.target.value);
                            } else {
                              setMeta(null);
                              ref.current.value = null;
                            }
                          }}
                          defaultValue={meta}
                          inputRef={ref}
                          endAdornment={
                            <Button
                              variant="contained"
                              className="btn3"
                              disabled={
                                ref?.current?.value.trim().length > 0
                                  ? false
                                  : true
                              }
                              onClick={() => handleChipAdd()}
                            >
                              Add
                            </Button>
                          }
                        />
                        <FormHelperText error></FormHelperText>
                        <Stack
                          direction="row"
                          spacing={1}
                          style={{ display: " inline" }}
                        >
                          {metaTag.map((i, element) => (
                            <>
                              <Chip
                                label={i}
                                variant="outlined"
                                style={{ marginTop: "5px" }}
                                className=""
                                onDelete={() => handleChipDelete(i)}
                              />
                            </>
                          ))}
                        </Stack>
                      </FormControl>

                    </Stack>

                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Subject
                        </InputLabel>
                        <Controller
                          name="subjects"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <Select
                              {...field}
                              multiple
                              value={watch('subjects', [])}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                setValue('subjects', typeof value === 'string' ? value.split(',') : value);
                                field.onChange(e);
                              }}
                              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                              renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((value) => (
                                    <Chip key={value} label={subjectList.find(obj => obj.id === value)?.title || ""} />
                                  ))}
                                </Box>
                              )}
                              MenuProps={MenuProps}
                            >
                              {subjectList.map((obj) => (
                                <MenuItem
                                  key={obj.title}
                                  value={obj.id}
                                  style={getStyles(obj.title, watch('subjects', []), theme)}
                                >
                                  {obj.title}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        {errors.subjects && <span>{errors.subjects.message}</span>}
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Class
                        </InputLabel>
                        <Controller
                          name="pbl_class"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <Select
                              {...field}
                              multiple
                              value={watch('pbl_class', [])}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                setValue('pbl_class', typeof value === 'string' ? value.split(',') : value);
                                field.onChange(e);
                              }}
                              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                              renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((value) => (
                                    <Chip key={value} label={classList.find(obj => obj.id === value)?.title || ""} />
                                  ))}
                                </Box>
                              )}
                              MenuProps={MenuProps}
                            >
                              {classList.map((obj) => (
                                <MenuItem
                                  key={obj.title}
                                  value={obj.id}
                                  style={getStyles(obj.title, watch('pbl_class', []), theme)}
                                >
                                  {obj.title}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        {errors.pbl_class && <span>{errors.pbl_class.message}</span>}
                        <FormHelperText error>
                          {errors?.pbl_class?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>PBL Duration*</InputLabel>
                        <OutlinedInput
                          {...register("duration")}
                          label="PBL Duration"
                          name="duration"
                          id="outlined-adornment-email"
                          notched
                          value={duration}
                          onChange={(e) => handleDurtion(e)}
                          error={errors?.duration?.message}
                        />
                        <FormHelperText error>
                          {errors?.duration?.message}
                        </FormHelperText>

                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Approved
                        </InputLabel>
                        <Select
                          {...register("is_approved")}
                          label="Approved"

                          notched
                          id="outlined-adornment-category"

                          error={!!errors?.is_approved?.message}
                          value={is_approved != null ? is_approved : null}
                          onChange={(e) => setisApproved(e.target.value)}
                        >
                          <MenuItem value={"true"}>True</MenuItem>
                          <MenuItem value={"false"}>False</MenuItem>
                        </Select>

                        <FormHelperText error>
                          {errors?.is_approved?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Language
                        </InputLabel>
                        <Select
                          {...register("language")}
                          label="Language"
                          notched
                          id="outlined-adornment-category"
                          error={!!errors?.language?.message}
                          value={language ? language : null}
                          onChange={(e) => setLanguage(e.target.value)}
                        >
                          <MenuItem value={"hindi"}>Hindi</MenuItem>
                          <MenuItem value={"english"}>English</MenuItem>
                          <MenuItem value={"both"}>Both</MenuItem>
                        </Select>

                        <FormHelperText error>
                          {errors?.language?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>

                    <InputLabel>Thumbnail Image</InputLabel>
                    {imageLink ? (
                      <div className="image-item">
                        <img src={imageLink} alt="" width="320" height="180" />
                        <div className="image-item__btn-wrapper">
                          <Button
                            onClick={() => setImageLink(null)}
                            variant="contained"
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <ImageUploading

                        acceptType={['png', 'jpeg', 'jpg']}
                        value={images}
                        onChange={onUploadImage}
                        maxNumber={1}
                        dataURLKey="data_url"

                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                          errors,
                        }) => (
                          <>
                            <div className="upload__image-wrapper" style={{ marginTop: "2%", marginBottom: "2%" }}>
                              {imageList.length > 0 ? null : (
                                <Button
                                  type="button"
                                  variant="contained"
                                  style={
                                    isDragging ? { color: "red" } : undefined
                                  }
                                  onClick={onImageUpload}
                                  {...dragProps}
                                >
                                  Click or Drop here
                                </Button>
                              )}

                              {errors && (
                                <div>
                                  {errors.maxNumber && (
                                    <span>
                                      Number of selected images exceed maxNumber
                                    </span>
                                  )}
                                  {errors.acceptType && (
                                    <span>
                                      Your selected file type is not allow
                                    </span>
                                  )}
                                  {errors.maxFileSize && (
                                    <span>
                                      Selected file size exceed maxFileSize
                                    </span>
                                  )}
                                  {errors.resolution && (
                                    <span>
                                      Selected file is not match your desired
                                      resolution
                                    </span>
                                  )}
                                </div>
                              )}
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="320" height="180"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <Button
                                      onClick={() => onImageUpdate(index)}
                                      variant="contained"
                                      sx={{ mr: 2 }}
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      onClick={() => onImageRemove(index)}
                                      variant="contained"
                                    >
                                      Remove
                                    </Button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </ImageUploading>
                    )}
                    <InputLabel style={{ marginTop: "2%", }}>
                      Document
                    </InputLabel>
                    <Stack
                      direction="row"
                      spacing={1}
                      style={{ display: " inline" }}
                    >
                      {handOuts.map((i, element) => (
                        <>
                          <Chip
                            key={element}
                            label={i.fileName}
                            variant="outlined"
                            className=""
                            style={{ marginTop: "5px" }}
                            onDelete={() => handleHandoutDelete(i)}
                          />
                        </>
                      ))}
                    </Stack>
                    <input
                      accept="application/pdf"
                      style={{ display: "none" }}
                      id="raised-button-file"
                      type="file"
                      ref={refInput}
                      onChange={(e) => onUploadHandout(e.target?.files[0])}
                    />
                    <Stack
                      direction="row"
                      spacing={1}
                      style={{ display: " block", marginTop: "2%" }}
                    >
                      {handOuts.length > 0 ? null : <Button
                        variant="contained"
                        color="primary"
                        onClick={() => refInput.current.click()}
                      >
                        Upload File
                      </Button>}
                    </Stack>
                  </>
                  {/* } */}
                </Stack>
              </Card>
              <Button
                type="button"
                sx={{ float: "right", mt: 2, ml: 2 }}
                variant="contained"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{ float: "right", mt: 2 }}
                variant="contained"
              >
                {params.id ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Body>
      <BackdropUI open={fileUploadLoader} />
    </>
  );
}
